/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql, Link } from "gatsby";

import "./reset.css";
import "./layout.css";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          authorName
        }
      }
    }
  `);

  return (
    <>
      <div className="content">
        <main>{children}</main>
        <footer>
          <div>
            <span className="copy">©</span> {new Date().getFullYear()}{" "}
            <Link to="/">{data.site.siteMetadata.authorName}</Link>
          </div>
          <div className="thistle">⚘</div>
        </footer>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
